// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"61f475a9","653":"a4b4efe4","818":"61f475a9"}[chunkId] + ".chunk.css";
};